import {Action} from '@ngrx/store';
import {SupplementalSalary} from '@app/core/models/supplementalSalary.model';
import {Pagination} from '@app/core/models/pagination.model';
import {ISupplementalSalaryFilter} from '@app/core/services/api/supplementalSalary.service';

export enum ESupplementalSalaryActions {
	GetSupplementalSalaries = '[SupplementalSalary] Get Supplemental Salaries',
	GetSupplementalSalariesSuccess = '[SupplementalSalary] Get Supplemental Salaries Success',

	PostSupplementalSalary = '[SupplementalSalary] Post Supplemental Salary',
	PostSupplementalSalarySuccess = '[SupplementalSalary] Post Supplemental Salary Success',

	PatchSupplementalSalary = '[SupplementalSalary] Patch Supplemental Salary',
	PatchSupplementalSalarySuccess = '[SupplementalSalary] Patch Supplemental Salary Success',

	DeleteSupplementalSalary = '[SupplementalSalary] Delete Supplemental Salary',
	DeleteSupplementalSalarySuccess = '[SupplementalSalary] Delete Supplemental Salary Success',

	GetSupplementalSalary = '[SupplementalSalary] Get Supplemental Salary',
	GetSupplementalSalarySuccess = '[SupplementalSalary] Get Supplemental Salary Success',

	ClearSupplementalSalaries = '[SupplementalSalary] Clear Supplemental Salaries',
	ClearEditingSupplementalSalary = '[SupplementalSalary] Clear Editing Supplemental Salary',
}

export class GetSupplementalSalaries implements Action {
	public readonly type = ESupplementalSalaryActions.GetSupplementalSalaries;
	public filters: ISupplementalSalaryFilter = {};

	constructor() {
		this.filters = {
			include: 'groups,group_users',
		};
	}
}

export class GetSupplementalSalariesSuccess implements Action {
	public readonly type = ESupplementalSalaryActions.GetSupplementalSalariesSuccess;

	constructor(public supplementalSalaries: SupplementalSalary[], public pagination: Pagination) {
	}
}

export class PostSupplementalSalary implements Action {
	public readonly type = ESupplementalSalaryActions.PostSupplementalSalary;

	constructor(public payload: {}) {
	}
}

export class PostSupplementalSalarySuccess implements Action {
	public readonly type = ESupplementalSalaryActions.PostSupplementalSalarySuccess;

	constructor(public supplementalSalary: SupplementalSalary) {
	}
}

export class PatchSupplementalSalary implements Action {
	public readonly type = ESupplementalSalaryActions.PatchSupplementalSalary;

	constructor(public id: number, public payload: {}) {
	}
}

export class PatchSupplementalSalarySuccess implements Action {
	public readonly type = ESupplementalSalaryActions.PatchSupplementalSalarySuccess;

	constructor(public supplementalSalary: SupplementalSalary) {
	}
}

export class DeleteSupplementalSalary implements Action {
	public readonly type = ESupplementalSalaryActions.DeleteSupplementalSalary;

	constructor(public id: number) {
	}
}

export class DeleteSupplementalSalarySuccess implements Action {
	public readonly type = ESupplementalSalaryActions.DeleteSupplementalSalarySuccess;

	constructor(public supplementalSalary: SupplementalSalary) {
	}
}

export class GetSupplementalSalary implements Action {
	public readonly type = ESupplementalSalaryActions.GetSupplementalSalary;

	constructor(public id: number) {
	}
}

export class GetSupplementalSalarySuccess implements Action {
	public readonly type = ESupplementalSalaryActions.GetSupplementalSalarySuccess;

	constructor(public supplementalSalary: SupplementalSalary) {
	}
}

export class ClearSupplementalSalaries implements Action {
	public readonly type = ESupplementalSalaryActions.ClearSupplementalSalaries;

	constructor() {
	}
}

export class ClearEditingSupplementalSalary implements Action {
	public readonly type = ESupplementalSalaryActions.ClearEditingSupplementalSalary;

	constructor() {
	}
}

export type SupplementalSalaryActions =
	GetSupplementalSalaries |
	GetSupplementalSalariesSuccess |
	PostSupplementalSalary |
	PostSupplementalSalarySuccess |
	PatchSupplementalSalary |
	PatchSupplementalSalarySuccess |
	DeleteSupplementalSalary |
	DeleteSupplementalSalarySuccess |
	GetSupplementalSalary |
	GetSupplementalSalarySuccess |
	ClearSupplementalSalaries |
	ClearEditingSupplementalSalary
	;
